import { fromJS } from 'immutable';
import { endLoad, startLoad } from 'portaltransparencia-common/crud/Core.js';

import * as types from './Types.js';

const initialState = fromJS({
  permutas: []
});

function permutaReducer(state = initialState, action) {
  switch (action.type) {
    case types.PERMUTAS_LIST_START: {
      return startLoad(state);
    }

    case types.PERMUTAS_LIST_SUCCESS: {
      return endLoad(state.set('permutas', fromJS(action.payload)));
    }

    case types.PERMUTAS_LIST_ERROR: {
      return endLoad(state);
    }
  }

  return state;
}

export default permutaReducer;
